<div class="b2a-snackbar__align-container {{ snackbarDisplayState }}">
  <div class="b2a-snackbar__container">
    <div class="b2a-snackbar__content" [ngStyle]="{ 'background-color': snackbarOptions.color }">
      <img src="assets/icons/general/close.svg" class="b2a-snackbar__dismiss-button" (click)="dismiss()" alt="Close Button"/>

      <div class="b2a-snackbar__message">
        {{ snackbarOptions.message }}

        <app-button
          *ngFor="let button of snackbarOptions.buttons"
          class="b2a-snackbar__button"
          [type]="button.style"
          [label]="button.label"
          [size]="'large'"
          (click)="buttonClicked(button.action)"
        >
        </app-button>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/user-notification/user-notification.component.html